"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _5FW7ADLFcjs = require('../__chunks/5FW7ADLF.cjs');
require('../__chunks/IRJEBRAW.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-item-check.tsx
var _react = require('react');
var TagName = "span";
var useMenuItemCheck = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuItemCheck2({ store, checked, ...props }) {
    const context = _react.useContext.call(void 0, _XXF5DFSGcjs.MenuItemCheckedContext);
    checked = checked != null ? checked : context;
    props = _5FW7ADLFcjs.useCheckboxCheck.call(void 0, { ...props, checked });
    return props;
  }
);
var MenuItemCheck = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuItemCheck2(props) {
  const htmlProps = useMenuItemCheck(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuItemCheck = MenuItemCheck; exports.useMenuItemCheck = useMenuItemCheck;
